var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCopilot = function SvgCopilot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 79 75",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.573 0a15.643 15.643 0 0115.643 15.643V46.93a15.643 15.643 0 01-15.643 15.643H44.098L25.475 73.746a3.91 3.91 0 01-5.898-2.906l-.023-.445v-7.822h-3.91A15.643 15.643 0 01.02 47.712L0 46.93V15.643A15.643 15.643 0 0115.643 0h46.93z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.002 23.816a7.473 7.473 0 100 14.946 7.473 7.473 0 100-14.946zm31.624-9.372c.831 0 1.505.674 1.505 1.505a13.585 13.585 0 0013.585 13.585 1.506 1.506 0 010 3.01 13.586 13.586 0 00-13.585 13.585l-.008.153a1.506 1.506 0 01-2.994 0l-.008-.153-.003-.338a13.587 13.587 0 00-13.582-13.247 1.505 1.505 0 01-.154-3.002l.154-.008.337-.004a13.585 13.585 0 0013.248-13.581c0-.831.674-1.505 1.505-1.505z"
  })));
};
export default SvgCopilot;